module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/_library.js
// module id = XAet
// module chunks = 0